import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useHistory } from "react-router-dom";
import PercentField from './PercentField';
import ListExceptions from './ListExceptions';
import ListExceptionsActions from './ListExceptionsActions';
import Spinner from 'react-bootstrap/Spinner';

const ModalExceptionsUpdate = ({ doCloseModalExceptions, opened, service, profesional, thirds }) => {
    const history = useHistory();

    //Listado
    const [execptionsFees, setExceptionsFees] = React.useState([]);

    //Formulario
    const [exceptionId, setExceptionId] = React.useState(null); 
    const [typeFee, setTypeFee] = React.useState(1);
    const [valor, setValor] = React.useState(null);
    const [third, setThird] = React.useState(null);


    //Estado del Modal
    const [agregar, setAgregar] = React.useState(false);
    const [actualizar, setActualizar] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(opened);
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    const refresh = async () => {
        setIsLoading(true);
        let url = `honorarios/listar-excepciones-profesional?id_profesional=${profesional.id_profesional}&id_servicio=${service.id_servicio}`;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            setIsLoading(false);
            setExceptionsFees(data);
        }).catch(err => {
            setIsLoading(false);
            setExceptionsFees([]);
        });
    }

    const addExceptions = async () => {
        if (third == null) {
            alertModal(false, "El Tercero es Obligatorio");
            return;
        }

        //Validacion si ya existe un Tercero de Excepcion para el servicio

        let existe = false;
        console.log(execptionsFees);
        if(execptionsFees != undefined && execptionsFees != null)
        {
            existe = execptionsFees.some(except => except.id_tercero == third);
        }

        if(existe == true)
        {
            alertModal(false, "Este Tercero ya tiene una excepción para este Servicio y Profesional");
            return;
        }

        let dataExceptions =
        {
            id_profesional: parseInt(profesional.id_profesional),
            id_servicio: parseInt(service.id_servicio),
            tipo: typeFee,
            valor: valor,
            id_tercero: parseInt(third)
        }
        let url = 'honorarios/create-exception';
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataExceptions)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                refresh();
                closeForm();
            }
            else {
                throw new Error('Error en Grabar el Honorario');
            }
        }).catch(err => {
            console.log(err);
            alertModal(false, "Ha ocurrido un error en el sistema");
        });


    }

    const updateFeeException = async () => {
        if (third == null) {
            alertModal(false, "El Tercero es Obligatorio");
            return;
        }
        let dataExceptions =
        {
            id_excepcion : exceptionId,
            tipo: typeFee,
            valor: valor,
            id_tercero: parseInt(third)
        }
        let url = 'honorarios/actualizar-excepcion';
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}${url}`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataExceptions)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                refresh();
                closeForm();
            }
            else {
                throw new Error('Error en Actualizar el Honorario');
            }
        }).catch(err => {
            console.log(err);
            alertModal(false, "Ha ocurrido un error en el sistema");
        });
    }

    const updateExceptions = (exception) => {
        setTypeFee(exception.tipo);
        setValor(exception.valor);
        setThird(exception.id_tercero);
        setExceptionId(exception.id_excepcion);
        setAgregar(false);
        setActualizar(true);
    }

    const openFormAddException = () => {
        setTypeFee(service.tipo);
        setValor(service.valor);
        setThird(null);
        setExceptionId(null);
        setAgregar(true);
        setActualizar(false);
    }

    const closeForm = () => {
        setTypeFee(null);
        setValor(null);
        setThird(null);
        setExceptionId(null);
        setAgregar(false);
        setActualizar(false);
    }

    const closeModal = () => {
        doCloseModalExceptions();
    }

    React.useEffect(() => {
        setExceptionsFees(service.excepciones);
    }, []);

    const ExcepcionsProfesional = () => {
        return (
            <ListExceptions
                reactTableData={execptionsFees}
                ReactTableActions={ListExceptionsActions}
                profesional={profesional}
                updateExceptions={updateExceptions}
                refresh={refresh}
            />
        )
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    {agregar == false && actualizar == false ?
                        <div>
                            <div className="card__title">
                                <h5 className="bold-text">Excepciones</h5>
                            </div>
                            <Row>
                                <Col md={12}>
                                    <div className="text-center">
                                        <Button
                                            disabled={false}
                                            style={{ marginTop: 10, marginRight: 10 }}
                                            variant="contained"
                                            className="btn btn-primary btn-sm text-white"
                                            onClick={() => {
                                                openFormAddException();
                                            }}
                                        >
                                            Agregar
                                        </Button>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    {isLoading == false ? <ExcepcionsProfesional />: <Spinner animation="border" variant="success" />}
                                </Col>
                            </Row>
                        </div>
                        :
                        <div>
                            <div className="card__title">
                                <h5 className="bold-text">Excepción</h5>
                            </div>
                            <Row>
                                <Col md={6}>
                                    <TextField
                                        label="Nombre del Profesional"
                                        defaultValue={
                                            profesional.apellido2 != null ?
                                                profesional.nombres + ' ' + profesional.apellido1 + ' ' + profesional.apellido2 :
                                                profesional.nombres + ' ' + profesional.apellido1
                                        }
                                        disabled={true}
                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                    />
                                </Col>
                                <Col md={6}>
                                    <TextField
                                        label="Nombre del Servicio"
                                        value={service.nombre}
                                        disabled={true}
                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                    />
                                </Col>
                                <Col md={6}>
                                    <TextField
                                        select
                                        label="Tipo de Honorario"
                                        value={typeFee}
                                        onChange={(e) => setTypeFee(e.target.value)}
                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                    >
                                        <MenuItem key={1} value={1}>
                                            Porcentaje
                                        </MenuItem>
                                        <MenuItem key={2} value={2}>
                                            Fijo
                                        </MenuItem>
                                    </TextField>
                                </Col>
                                <Col md={6}>
                                    {
                                        typeFee == 1 ? <TextField
                                            label="Valor"
                                            value={valor}
                                            onChange={(event) => {
                                                setValor(event.target.value);
                                            }}
                                            className='medical-material-form__field'
                                            InputProps={{
                                                inputComponent: PercentField
                                            }}
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        />
                                            :
                                            <TextField
                                                label="Valor"
                                                value={valor}
                                                type="number"
                                                onChange={(e) => setValor(e.target.value)}
                                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' }
                                                }}
                                            />
                                    }
                                </Col>
                                <Col md={6}>
                                    <TextField
                                        select
                                        label="Tercero"
                                        value={third}
                                        onChange={(e) => setThird(e.target.value)}
                                        style={{ minWidth: '300px', maxWidth: '100%' }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            style: { color: '#646777' }
                                        }}
                                    >
                                        {thirds.map((tercero) => {
                                            return <MenuItem key={tercero.id_tercero} value={tercero.id_tercero}>
                                                {tercero.nombre}
                                            </MenuItem>
                                        })}
                                    </TextField>
                                </Col>
                            </Row>
                        </div>
                    }

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {agregar == true ? <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                addExceptions();
                            }}
                        >
                            Guardar
                        </Button> : null}

                        {actualizar == true ? <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                updateFeeException();
                            }}
                        >
                            Actualizar
                        </Button> : null}

                        {
                            actualizar == true || agregar == true ?
                                <Button
                                    disabled={false}
                                    style={{ marginTop: 10, marginRight: 10 }}
                                    variant="contained"
                                    className="btn btn-gray btn-sm"
                                    onClick={() => {
                                        setAgregar(false);
                                        setActualizar(false);
                                    }}
                                >
                                    Cancelar
                                </Button> : null
                        }

                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => setAlerShowModal(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalExceptionsUpdate;
